import React, { useEffect, useLayoutEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {
  CHART_COLORS,
  CHART_COLORS_THREE,
  CHART_MAX_VALUES,
  productColors,
  RANDOM_CHART_COLORS,
} from "constant/variables";

am4core.useTheme(am4themes_animated);

export default function BulletPieChartOutlet(props) {
  const [viewData, setViewData] = useState([]);
  const { outletper } = props;
  console.log("BulletPieChartOutlet Render", outletper);
  useEffect(() => {
    if (outletper) {
      if (outletper.length === 0) {
        const viewDetail = [];
        const details = {
          country: "Data Not Available",
          units: 0,
          second: 0,
        };
        viewDetail.push(details);
        setViewData(viewDetail);
      } else {
        const clinic = outletper;
        const viewDetail = [];
        let count = 0;
        console.log("BulletPieChartOutlet useEffect", outletper);
        for (let index = 0; index < clinic.length; index++) {
          if (count + 1 > CHART_MAX_VALUES) {
            break;
          }
          if (props.region && props.region !== clinic[index].Region) {
          } else {
            const details = {
              country: clinic[index].OutletName,
              litres: clinic[index].TotalSales,
              target: clinic[index].TotalTarget,
              achieved_percentage: clinic[index].TotalAchievedPercentage,
              color: RANDOM_CHART_COLORS[count],
              subData: [
                {
                  value: clinic[index].BaqatiSales,
                  name: "Baqati",
                  target: clinic[index].BaqatiTarget,
                  achieved_percentage: clinic[index].BaqatiAchievedPercentage,
                  color: productColors.Baqati,
                },
                {
                  value: clinic[index].HayyakSales,
                  name: "Hayyak",
                  target: clinic[index].HayyakTarget,
                  achieved_percentage: clinic[index].HayyakAchievedPercentage,
                  color: productColors.Hayyak,
                },
                {
                  value: clinic[index].HBBSales,
                  name: "HBB",
                  target: clinic[index].HBBTarget,
                  achieved_percentage: clinic[index].HBBAchievedPercentage,
                  color: productColors.HBB,
                },
                {
                  value: clinic[index].UpgradeSales,
                  name: "Upgrade",
                  target: clinic[index].UpgradeTarget,
                  achieved_percentage: clinic[index].UpgradeAchievedPercentage,
                  color: productColors.Upgrade,
                },
              ],
            };
            // const details = {
            //     "country": clinic[index].OutletName,
            //     "units": clinic[index].TotalSales,
            //     "pie": []
            // }
            count++;
            viewDetail.push(details);
          }
        }

        setViewData(viewDetail);
      }
    }
  }, [outletper, props.region]);

  const gotoOutletChart = (ev) => {
    const columnData = ev.target._dataItem?._dataContext || {};
    console.log("clicked on ", ev.target, columnData.country);
    props.onSelect(columnData.country);
    document.getElementById("employeeTargetId").scrollIntoView({
      behavior: "smooth",
    });
  };

  useLayoutEffect(() => {
    let container = am4core.create("chartdiv3451", am4core.Container);
    container.width = am4core.percent(100);
    container.height = am4core.percent(100);
    container.layout = "horizontal";

    let chart = container.createChild(am4charts.PieChart);

    // Add data
    chart.data = viewData;

    // Add and configure Series
    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "litres";
    pieSeries.dataFields.category = "country";
    pieSeries.slices.template.states.getKey("active").properties.shiftRadius =
      0;
    //pieSeries.labels.template.text = "{category}\n{value.percent.formatNumber('#.#')}%";
    pieSeries.slices.template.tooltipText =
      "Outlet: {country}\nTarget: {target}\nSales: {litres}\nAchievement: {achieved_percentage}%";
    pieSeries.slices.template.propertyFields.fill = "color";
    pieSeries.slices.template.events.on("hit", function (event) {
      selectSlice(event.target.dataItem);
    });
    pieSeries.labels.template.text = "{country}";

    pieSeries.labels.template.events.on("hit", gotoOutletChart);

    let chart2 = container.createChild(am4charts.PieChart);
    chart2.width = am4core.percent(30);
    chart2.radius = am4core.percent(80);

    // Add and configure Series
    let pieSeries2 = chart2.series.push(new am4charts.PieSeries());
    pieSeries2.dataFields.value = "value";
    pieSeries2.dataFields.category = "name";
    pieSeries2.slices.template.states.getKey("active").properties.shiftRadius =
      0;
    //pieSeries2.labels.template.radius = am4core.percent(50);
    //pieSeries2.labels.template.inside = true;
    //pieSeries2.labels.template.fill = am4core.color("#ffffff");
    pieSeries2.labels.template.disabled = true;
    pieSeries2.ticks.template.disabled = true;
    pieSeries2.alignLabels = false;
    pieSeries2.events.on("positionchanged", updateLines);
    pieSeries2.slices.template.tooltipText =
      "Product: {name}\nTarget: {target}\nSales: {value}\nAchievement: {achieved_percentage}%";
    pieSeries2.slices.template.propertyFields.fill = "color";
    let interfaceColors = new am4core.InterfaceColorSet();

    let line1 = container.createChild(am4core.Line);
    line1.strokeDasharray = "2,2";
    line1.strokeOpacity = 0.5;
    line1.stroke = interfaceColors.getFor("alternativeBackground");
    line1.isMeasured = false;

    let line2 = container.createChild(am4core.Line);
    line2.strokeDasharray = "2,2";
    line2.strokeOpacity = 0.5;
    line2.stroke = interfaceColors.getFor("alternativeBackground");
    line2.isMeasured = false;

    let selectedSlice;

    function selectSlice(dataItem) {
      if (!dataItem || !dataItem.dataContext || !dataItem.dataContext.subData) {
        return;
      }

      selectedSlice = dataItem.slice;

      let fill = selectedSlice.fill;

      let count = dataItem.dataContext.subData.length;
      pieSeries2.colors.list = [];
      for (var i = 0; i < count; i++) {
        pieSeries2.colors.list.push(fill.brighten((i * 2) / count));
      }

      chart2.data = dataItem.dataContext.subData;
      pieSeries2.appear();

      let middleAngle = selectedSlice.middleAngle;
      let firstAngle = pieSeries.slices.getIndex(0).startAngle;
      let animation = pieSeries.animate(
        [
          { property: "startAngle", to: firstAngle - middleAngle },
          { property: "endAngle", to: firstAngle - middleAngle + 360 },
        ],
        600,
        am4core.ease.sinOut,
      );
      animation.events.on("animationprogress", updateLines);

      selectedSlice.events.on("transformed", updateLines);

      //  var animation = chart2.animate({property:"dx", from:-container.pixelWidth / 2, to:0}, 2000, am4core.ease.elasticOut)
      //  animation.events.on("animationprogress", updateLines)
    }

    function updateLines() {
      if (selectedSlice) {
        let p11 = {
          x: selectedSlice.radius * am4core.math.cos(selectedSlice.startAngle),
          y: selectedSlice.radius * am4core.math.sin(selectedSlice.startAngle),
        };
        let p12 = {
          x:
            selectedSlice.radius *
            am4core.math.cos(selectedSlice.startAngle + selectedSlice.arc),
          y:
            selectedSlice.radius *
            am4core.math.sin(selectedSlice.startAngle + selectedSlice.arc),
        };

        p11 = am4core.utils.spritePointToSvg(p11, selectedSlice);
        p12 = am4core.utils.spritePointToSvg(p12, selectedSlice);

        let p21 = { x: 0, y: -pieSeries2.pixelRadius };
        let p22 = { x: 0, y: pieSeries2.pixelRadius };

        p21 = am4core.utils.spritePointToSvg(p21, pieSeries2);
        p22 = am4core.utils.spritePointToSvg(p22, pieSeries2);

        line1.x1 = p11.x;
        line1.x2 = p21.x;
        line1.y1 = p11.y;
        line1.y2 = p21.y;

        line2.x1 = p12.x;
        line2.x2 = p22.x;
        line2.y1 = p12.y;
        line2.y2 = p22.y;
      }
    }

    chart.events.on("datavalidated", function () {
      setTimeout(function () {
        selectSlice(pieSeries.dataItems.getIndex(0));
      }, 1000);
    });

    // var chart = am4core.create("chartdiv3451", am4charts.XYChart);

    // chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    // // Add data
    // chart.data = viewData
    // // chart.data = [{
    // //     "country": "Lithuania",
    // //     "units": 500,
    // //     "pie": [{
    // //         "value": 250,
    // //         "title": "Cat #1"
    // //     }, {
    // //         "value": 150,
    // //         "title": "Cat #2"
    // //     }, {
    // //         "value": 100,
    // //         "title": "Cat #3"
    // //     }]
    // // }, {
    // //     "country": "Czechia",
    // //     "units": 300,
    // //     "pie": [{
    // //         "value": 80,
    // //         "title": "Cat #1"
    // //     }, {
    // //         "value": 130,
    // //         "title": "Cat #2"
    // //     }, {
    // //         "value": 90,
    // //         "title": "Cat #3"
    // //     }]
    // // }, {
    // //     "country": "Ireland",
    // //     "units": 30,
    // //     "pie": [{
    // //         "value": 75,
    // //         "title": "Cat #1"
    // //     }, {
    // //         "value": 55,
    // //         "title": "Cat #2"
    // //     }, {
    // //         "value": 70,
    // //         "title": "Cat #3"
    // //     }]
    // // }];

    // // Modify chart's colors
    // chart.colors.list = [am4core.color("#f89d21")];

    // // Create axes
    // var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    // categoryAxis.dataFields.category = "country";
    // categoryAxis.renderer.grid.template.disabled = true;

    // categoryAxis.renderer.labels.template.events.on("hit", gotoOutletChart);

    // var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // valueAxis.title.text = "Units sold (M)";
    // valueAxis.min = 0;
    // valueAxis.renderer.baseGrid.disabled = true;
    // valueAxis.renderer.grid.template.strokeOpacity = 0.07;

    // // Create series
    // var series = chart.series.push(new am4charts.ColumnSeries());
    // series.dataFields.valueY = "units";
    // series.dataFields.categoryX = "country";
    // series.tooltip.pointerOrientation = "vertical";

    // series.columns.template.events.on("hit", gotoOutletChart, this);

    // var columnTemplate = series.columns.template;
    // // add tooltip on column, not template, so that slices could also have tooltip
    // columnTemplate.column.tooltipText = "Series: {name}\nOutlet: {categoryX}\nSales: {valueY}";
    // columnTemplate.column.tooltipY = 0;
    // columnTemplate.column.cornerRadiusTopLeft = 20;
    // columnTemplate.column.cornerRadiusTopRight = 20;
    // columnTemplate.strokeOpacity = 0;

    // // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
    // // columnTemplate.adapter.add("fill", function (fill, target) {
    // //     var color = chart.colors.getIndex(target.dataItem.index * 3);
    // //     return color;
    // // });

    // // create pie chart as a column child
    // var pieChart = series.columns.template.createChild(am4charts.PieChart);
    // pieChart.width = am4core.percent(80);
    // pieChart.height = am4core.percent(80);
    // pieChart.align = "center";
    // pieChart.valign = "middle";
    // pieChart.dataFields.data = "pie";

    // var pieSeries = pieChart.series.push(new am4charts.PieSeries());
    // pieSeries.dataFields.value = "value";
    // pieSeries.dataFields.category = "title";
    // pieSeries.labels.template.disabled = true;
    // pieSeries.ticks.template.disabled = true;
    // pieSeries.slices.template.strokeWidth = 1;
    // // pieSeries.slices.template.tooltipText = "{title}: {achieved_percentage}% (T:{target}/S:{value})";
    // pieSeries.slices.template.tooltipText = "Product: {title}\nTarget: {target}\nSales: {value}\nAchievement: {achieved_percentage}%";

    // pieSeries.slices.template.adapter.add("stroke", function (stroke, target) {
    //     return chart.colors.getIndex(target.parent.parent.dataItem.index * 3);
    // });

    // pieSeries.slices.template.adapter.add("fill", function (fill, target) {
    //     return am4core.color("#ffffff")
    // });

    // pieSeries.slices.template.adapter.add("fillOpacity", function (fillOpacity, target) {
    //     return (target.dataItem.index + 1) * 0.2;
    // });

    // pieSeries.hiddenState.properties.startAngle = -90;
    // pieSeries.hiddenState.properties.endAngle = 270;

    // // this moves the pie out of the column if column is too small
    // pieChart.adapter.add("verticalCenter", function (verticalCenter, target) {
    //     var point = am4core.utils.spritePointToSprite({ x: 0, y: 0 }, target.seriesContainer, chart.plotContainer);
    //     point.y -= target.dy;

    //     if (point.y > chart.plotContainer.measuredHeight - 15) {
    //         target.dy = -target.seriesContainer.measuredHeight - 15;
    //     }
    //     else {
    //         target.dy = 0;
    //     }
    //     return verticalCenter
    // })

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return <div id="chartdiv3451" style={{ width: "100%", height: "500px" }} />;
}
